export const loggedIStatenQueryParam = 'loggedin' as const;

export enum LoggedInStateTypes {
    LoggedIn = 'true',
    LoggedOut = 'false',
}
